import { ContractStageType } from "../../models/Entities/Contracts/ContractStageType";
import { ErrorType } from "../../models/HttpError";

export const CONTRACTSTAGETYPE_GET_ALL_REQUEST = 'CONTRACTSTAGETYPE_GET_ALL_REQUEST';
export const CONTRACTSTAGETYPE_GET_ALL_SUCCESS = 'CONTRACTSTAGETYPE_GET_ALL_SUCCESS';
export const CONTRACTSTAGETYPE_GET_ALL_FAILURE = 'CONTRACTSTAGETYPE_GET_ALL_FAILURE';

export interface ContractStageTypeGetAllRequestAction {
    type: typeof CONTRACTSTAGETYPE_GET_ALL_REQUEST;
}

export interface ContractStageTypeGetAllSuccessAction {
    type: typeof CONTRACTSTAGETYPE_GET_ALL_SUCCESS;
    StageTypes: ContractStageType[];
}

export interface ContractStageTypeGetAllFailureAction {
    type: typeof CONTRACTSTAGETYPE_GET_ALL_FAILURE;
    error: ErrorType;
}

export const CONTRACTSTAGETYPE_GET_BY_ID_REQUEST = 'CONTRACTSTAGETYPE_GET_BY_ID_REQUEST';
export const CONTRACTSTAGETYPE_GET_BY_ID_SUCCESS = 'CONTRACTSTAGETYPE_GET_BY_ID_SUCCESS';
export const CONTRACTSTAGETYPE_GET_BY_ID_FAILURE = 'CONTRACTSTAGETYPE_GET_BY_ID_FAILURE';

export interface ContractStageTypeGetByIdRequestAction {
    type: typeof CONTRACTSTAGETYPE_GET_BY_ID_REQUEST;
}

export interface ContractStageTypeGetByIdSuccessAction {
    type: typeof CONTRACTSTAGETYPE_GET_BY_ID_SUCCESS;
    StageType: ContractStageType;
}

export interface ContractStageTypeGetByIdFailureAction {
    type: typeof CONTRACTSTAGETYPE_GET_BY_ID_FAILURE;
    error: ErrorType;
}

export const CONTRACTSTAGETYPE_CREATE_REQUEST = 'CONTRACTSTAGETYPE_CREATE_REQUEST';
export const CONTRACTSTAGETYPE_CREATE_SUCCESS = 'CONTRACTSTAGETYPE_CREATE_SUCCESS';
export const CONTRACTSTAGETYPE_CREATE_FAILURE = 'CONTRACTSTAGETYPE_CREATE_FAILURE';

export interface ContractStageTypeCreateRequestAction {
    type: typeof CONTRACTSTAGETYPE_CREATE_REQUEST;
    StageType: ContractStageType;
}

export interface ContractStageTypeCreateSuccessAction {
    type: typeof CONTRACTSTAGETYPE_CREATE_SUCCESS;
    StageType: ContractStageType;
}

export interface ContractStageTypeCreateFailureAction {
    type: typeof CONTRACTSTAGETYPE_CREATE_FAILURE;
    error: ErrorType;
}

export const CONTRACTSTAGETYPE_UPDATE_REQUEST = 'CONTRACTSTAGETYPE_UPDATE_REQUEST';
export const CONTRACTSTAGETYPE_UPDATE_SUCCESS = 'CONTRACTSTAGETYPE_UPDATE_SUCCESS';
export const CONTRACTSTAGETYPE_UPDATE_FAILURE = 'CONTRACTSTAGETYPE_UPDATE_FAILURE';

export interface ContractStageTypeUpdateRequestAction {
    type: typeof CONTRACTSTAGETYPE_UPDATE_REQUEST;
    StageType: ContractStageType;
}

export interface ContractStageTypeUpdateSuccessAction {
    type: typeof CONTRACTSTAGETYPE_UPDATE_SUCCESS;
    StageType: ContractStageType;
}

export interface ContractStageTypeUpdateFailureAction {
    type: typeof CONTRACTSTAGETYPE_UPDATE_FAILURE;
    error: ErrorType;
}

export const CONTRACTSTAGETYPE_DELETE_REQUEST = 'CONTRACTSTAGETYPE_DELETE_REQUEST';
export const CONTRACTSTAGETYPE_DELETE_SUCCESS = 'CONTRACTSTAGETYPE_DELETE_SUCCESS';
export const CONTRACTSTAGETYPE_DELETE_FAILURE = 'CONTRACTSTAGETYPE_DELETE_FAILURE';

export interface ContractStageTypeDeleteRequestAction {
    type: typeof CONTRACTSTAGETYPE_DELETE_REQUEST;
    id: number;
}

export interface ContractStageTypeDeleteSuccessAction {
    type: typeof CONTRACTSTAGETYPE_DELETE_SUCCESS;
    id: number;
}

export interface ContractStageTypeDeleteFailureAction {
    type: typeof CONTRACTSTAGETYPE_DELETE_FAILURE;
    error: ErrorType;
}



